import firebase from '../../lib/firebase.prod';

export function signout() {
	firebase.auth().signOut();
}
